export function parseHistoricalPeriodsMarkdown(markdown) {
  const seen = new Set();
  const periods = [];

  String(markdown || '').split(/\r?\n/).forEach((line) => {
    const trimmed = line.trim();
    const listMatch = /^(?:(?:[-*+]|\u2022|\u2023|\u25e6|\u2043|\u2219|\u00e2\u20ac\u00a2)\s*|\d+[.)]\s+)(.+)$/.exec(trimmed);
    if (!listMatch) return;

    const content = listMatch[1].trim();
    const mdMatch = /\*\*(.*?)\*\*\s*(?:\(([^)]+)\)|\[([^\]]+)\]|\{([^}]+)\})/.exec(content);
    if (!mdMatch) return;

    const title = mdMatch[1].trim();
    const date = (mdMatch[2] || mdMatch[3] || mdMatch[4] || '').trim();
    const key = title.toLowerCase();
    if (!title || !date || seen.has(key)) return;

    seen.add(key);
    periods.push({ title, date });
  });

  return periods;
}
